module.exports = __webpack_public_path__ + "static/media/send--light.edc2c72a.svg";